module.exports = __webpack_public_path__ + "img/Amago_Panico_Amago.49b66e0e.svg";